const OPEN = /<email-quote\b[^>]*>/i
const CLOSE = '</email-quote>'
const WROTE = /On [^<]{10,300}?wrote:/i
const ORIGINAL = /-{2,}\s*Original Message\s*-{2,}/i

export function splitEmailQuote(html: string): {
  visible: string
  quoted: string | null
} {
  const marked = splitMarked(html)
  if (marked) return marked
  return splitHeader(html) ?? { visible: html, quoted: null }
}

function splitMarked(html: string) {
  const open = html.search(OPEN)
  if (open < 0) return null
  const openEnd = html.indexOf('>', open) + 1
  const close = html.toLowerCase().lastIndexOf(CLOSE)
  if (close < openEnd) return null
  const visible = `${html.slice(0, open)}${html.slice(close + CLOSE.length)}`
  const quoted = html.slice(openEnd, close)
  return visibleText(visible)
    ? { visible, quoted }
    : { visible: html, quoted: null }
}

function splitHeader(html: string) {
  const match = WROTE.exec(html) ?? ORIGINAL.exec(html)
  if (!match || match.index <= 0) return null
  if (WROTE.test(match[0]) && !looksLikeEmailQuote(match[0])) return null
  const visible = html.slice(0, match.index)
  return visibleText(visible)
    ? { visible, quoted: html.slice(match.index) }
    : null
}

function looksLikeEmailQuote(header: string) {
  return header.includes('@') || /\b\d{4}\b/.test(header)
}

function visibleText(html: string) {
  return html
    .replace(/<[^>]+>/g, ' ')
    .replace(/&nbsp;/gi, ' ')
    .trim()
    .length > 0
}
